const userContentConfig = {
  keyArgs: ['epubId'],
  merge(existing = { edges: [] }, incoming) {
    let uniqueExisting = [];
    if (existing?.edges?.[0]) {
      // make sure we don't have duplicating items
      uniqueExisting = existing.edges.filter((existingEdge) => {
        const isEntryAvailableInCache = incoming.edges.find((incomingEdge) => {
          return existingEdge?.node?.__ref === incomingEdge?.node?.__ref;
        });

        if (isEntryAvailableInCache) {
          return false;
        }

        return true;
      });
    }

    return {
      __typename: incoming.__typename,
      edges: [...uniqueExisting, ...incoming.edges],
    };
  },
};

export const APOLLO_CACHE_CONFIG = {
  typePolicies: {
    Query: {
      fields: {
        // only fields can be configured as long as we are using redshelf-data
        epubAnnotationsInDocument: userContentConfig,
        epubAnnotationsFromSharesInDocument: userContentConfig,
        epubBookmarksByEpub: userContentConfig,
        copiedTextsByEpub: userContentConfig,
        flashcardsByEpub: userContentConfig,
        flashcardDecksByEpub: userContentConfig,
        offlineSessionsByEpub: userContentConfig,
        epubAnnotationsNotInDocument: userContentConfig,
        epubAnnotationsFromSharesNotInDocument: userContentConfig,
      },
    },
  },
};
